import { ProfileContainer } from './container';

export const ProfileRoute = ProfileContainer;
